import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, errMsg } from "../../lib/api";

const F = ({ label, children }) => (
  <div>
    <label className="label">{label}</label>
    {children}
  </div>
);

export const VendorDialog = ({ vendor, onClose, onSaved }) => {
  const isNew = !vendor.id;
  const [f, setF] = useState({ name: vendor.name || "", code: vendor.code || "", gstin: vendor.gstin || "",
    location: vendor.location || "", payment_days: vendor.payment_days ?? 30 });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (isNew) {
      api.get("/vendors/next-code").then((r) => setF((x) => (x.code ? x : { ...x, code: r.data.code })));
    }
  }, [isNew]);

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = { ...f, payment_days: Number(f.payment_days) || 0 };
      if (isNew) await api.post("/vendors", body);
      else await api.put(`/vendors/${vendor.id}`, body);
      toast.success(isNew ? "Vendor added" : "Vendor updated");
      onSaved();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] max-w-[95vw] overflow-y-auto sm:max-w-md" data-testid="vendor-dialog">
        <DialogHeader><DialogTitle className="font-heading">{isNew ? "Add vendor" : "Edit vendor"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <F label="Vendor name *"><input className="field" required value={f.name} onChange={set("name")} data-testid="vendor-name-input" /></F>
          <div className="grid grid-cols-2 gap-3">
            <F label="Vendor code *"><input className="field mono" required value={f.code} onChange={set("code")} data-testid="vendor-code-input" /></F>
            <F label="Payment (days)"><input className="field mono" type="number" min="0" inputMode="numeric" value={f.payment_days} onChange={set("payment_days")} data-testid="vendor-payment-input" /></F>
          </div>
          <F label="GSTIN"><input className="field mono uppercase" maxLength={15} value={f.gstin} onChange={set("gstin")} data-testid="vendor-gstin-input" /></F>
          <F label="Location"><input className="field" value={f.location} onChange={set("location")} data-testid="vendor-location-input" /></F>
          <div className="grid grid-cols-2 gap-2">
            <button type="button" className="btn btn-outline" onClick={onClose} data-testid="vendor-cancel-btn">Cancel</button>
            <button className="btn btn-primary" disabled={busy} data-testid="vendor-save-btn">{busy && <Loader2 size={18} className="animate-spin" />} Save</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
